import React from 'react'
import {Badge, SubHeader} from '../..'
import { CheckRounded } from '@mui/icons-material'
import { disabilityServicesList } from '../../../utils/constants'

import './disabilityServices.css'

const DisabilityServices = () => {
  return (
    <>
      <div id='disability' className='disability-service-wrapper'>
        <Badge title="Intellectual Disabilities Services" />
        <SubHeader title="" description="We are committed to providing warm and professional care to our IDD friends and fellows" />
        <div className='disability-service-container'>
          <div className="disability-service-gradient-background"></div>
          <div className='disability-service-main-container'>
            <div className="disability-service-main-cover">
              {disabilityServicesList.map((result, index) => {
                return(
                  <div key={index} className="disability-service-main-box">
                    <span className="disability-service-main-grid">
                      <CheckRounded />
                    </span>
                    <span className="disability-service-main-text">{result.title}</span>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DisabilityServices